import React, { useState } from "react";
import contactServices from "../../Services/contactServices";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import Swal from "sweetalert2";
import "./Contact.css";

const Contact = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const form = event.target;
  
    const name = form.name.value;
    const email = form.email.value;
    const description = form.description.value;
  
    const contact = {
      name,
      email,
      description,
    };
  
    try {
      const res = await contactServices.postContact(contact);
  
      if (res?.status === "success") {
        Swal.fire({
          title: "Message Sent!",
          text: "We'll get back to you soon.",
          icon: "success",
          confirmButtonColor: "#3b82f6"
        });
  
        form.reset();
      } else {
        throw new Error(res?.message || "Failed to send message");
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.response?.data?.message || error.message || "An error occurred",
        icon: "error",
        confirmButtonColor: "#3b82f6"
      });
  
      console.error("Submission error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <div className="contact-container">
      <div className="contact-card">
        <div className="contact-header">
          <h1>Contact With Us</h1>
          <p>We'd love to hear from you!</p>
        </div>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="input-group">
            <PersonOutlineIcon className="input-icon" />
            <input
              required
              name="name"
              type="text"
              placeholder="Your Name"
              disabled={isLoading}
            />
          </div>

          <div className="input-group">
            <EmailOutlinedIcon className="input-icon" />
            <input
              required
              name="email"
              type="email"
              placeholder="Your Email"
              disabled={isLoading}
            />
          </div>

          <div className="input-group">
            <MessageOutlinedIcon className="input-icon" />
            <textarea
              required
              name="description"
              placeholder="Your Message"
              disabled={isLoading}
              rows="5"
            ></textarea>
          </div>

          <button type="submit" disabled={isLoading} className="contactBtn">
            {isLoading ? (
              "Sending Message..."
            ) : (
              <>
                <SendOutlinedIcon className="btn-icon" />
                Send Message
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;